import { ReactNode } from 'react'
import { useFormikContext } from 'formik'
import Loading from 'react-loading'
import {Button} from '../../../styled'
import { ButtonProps } from '@mui/material'

interface IValidatedButtonProps extends ButtonProps{
    children: ReactNode
    disabled?: boolean
    loading: boolean
    startIcon: JSX.Element
}

export default function ValidatedButton({children, disabled=false, loading=false, startIcon, ...props}:IValidatedButtonProps){

    const {handleSubmit} = useFormikContext()

    return(
        <Button 
            disabled={disabled}
            onClick={()=>handleSubmit()}
            startIcon={loading ? <Loading type="spin" height={20} width={20} color="#1A1B41" /> : startIcon}
            {...props}
        >
            {children}
        </Button>
    )
    
}